import { EventBus } from "../../../eventbus";
import { clamp, map } from "../../../functions/HelperFuncs";

export default {
  props: {
    file: Object,
    dims: Object,
  },
  data() {
    return {
      faces: [],
      currentlyEditingFace: false,
      showFaces: false,
      drawFace: false,
      showEditFaceInit: false,
      editingFace: false,
      tempFace: {
        top: `0%`,
        left: `0%`,
        width: `0%`,
        height: `0%`,
      },
    };
  },
  created() {
    this.faces = this.file.faces;

    EventBus.$on(`faces-overlay--show`, () => this.handleShow(true));

    EventBus.$on(`faces-overlay--hide`, () => this.handleShow(false));

    EventBus.$on(`faces-overlay--adding-face`, (status) =>
      this.setAddingFace(status)
    );

    EventBus.$on(`faces-overlay--add-face`, () => this.addFace());
    EventBus.$on(`faces-overlay--update-faces`, (faces) =>
      this.updateFaces(faces)
    );

    EventBus.$on(`faces--update`, (face) => this.handleUpdateFace(face));
    EventBus.$on(`faces--cancel`, () => this.handleCancel());
  },

  methods: {
    handleCancel() {
      this.currentlyEditingFace = false;
    },
    handleUpdateFace(face) {
      this.currentlyEditingFace = face;
    },
    updateFaces(faces) {
      this.currentlyEditingFace = false;
      this.faces = faces;
    },
    setAddingFace(status) {
      this.drawFace = status;
      this.showEditFaceInit = false;
    },
    handleShow(status) {
      this.showFaces = status;
    },
    createFace(face) {
      return {
        top: `${face.TL_y}%`,
        left: `${face.TL_x}%`,
        width: `${face.width}%`,
        height: `${face.height}%`,
      };
    },
    setTempWidthAndHeight(pos) {
      if (this.$refs.facesOverlay) {
        const box = this.$refs.facesOverlay.getBoundingClientRect();

        let height =
          map(pos.y, 0, box.height, 0, 100) -
          parseFloat(this.tempFace.topStart);

        let width =
          map(pos.x, 0, box.width, 0, 100) -
          parseFloat(this.tempFace.leftStart);

        if (height >= 0) {
          this.tempFace.height = `${clamp(height, 0, 100)}%`;
        } else {
          //also edit the top
          this.tempFace.height = `${clamp(Math.abs(height), 0, 100)}%`;
          this.tempFace.top = `${clamp(
            map(pos.y, 0, box.height, 0, 100),
            0,
            100
          )}%`;
        }

        if (width >= 0) {
          this.tempFace.width = `${clamp(width, 0, 100)}%`;
        } else {
          //also edit the top

          this.tempFace.width = `${clamp(Math.abs(width), 0, 100)}%`;
          this.tempFace.left = `${clamp(
            map(pos.x, 0, box.width, 0, 100),
            0,
            100
          )}%`;
        }
      }
    },
    handleMove(e) {
      if (this.drawFace && this.editingFace) {
        this.setTempWidthAndHeight({ x: e.layerX, y: e.layerY });
      }
    },
    handleDrawFace(e) {
      if (this.drawFace) {
        this.editingFace = true;
        this.showEditFaceInit = true;

        if (this.$refs.facesOverlay) {
          const box = this.$refs.facesOverlay.getBoundingClientRect();

          const top = `${clamp(map(e.layerY, 0, box.height, 0, 100), 0, 100)}%`;

          this.tempFace.top = top;
          this.tempFace.topStart = top;

          const left = `${clamp(map(e.layerX, 0, box.width, 0, 100), 0, 100)}%`;

          this.tempFace.left = left;
          this.tempFace.leftStart = left;

          this.tempFace.height = "0%";
          this.tempFace.width = "0%";
        }
      }
    },

    addFace() {
      if (parseInt(this.tempFace.width) && parseInt(this.tempFace.height)) {
        this.drawFace = false;

        //create new face
        const faceData = {
          TL_x: parseFloat(this.tempFace.left),
          TL_y: parseFloat(this.tempFace.top),
          TR_x:
            parseFloat(this.tempFace.left) + parseFloat(this.tempFace.width),
          TR_y: parseFloat(this.tempFace.top),
          BL_x: parseFloat(this.tempFace.left),
          BL_y:
            parseFloat(this.tempFace.top) + parseFloat(this.tempFace.height),
          BR_x:
            parseFloat(this.tempFace.left) + parseFloat(this.tempFace.width),
          BR_y:
            parseFloat(this.tempFace.top) + parseFloat(this.tempFace.height),
        };

        this.tempFace = {
          top: `0%`,
          left: `0%`,
          width: `0%`,
          height: `0%`,
        };

        //create placeholder

        EventBus.$emit("faces--add-face", faceData);
      }
    },
    handleCreateFace(e) {
      //reset values
      this.editingFace = false;
    },
  },
  watch: {
    currentlyEditingFace() {},
  },
};
